import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';
import { MessageType, MessageTypeTranslations } from 'src/app/core/interfaces/message.interface';

@Pipe({
    name: 'messageType',
    pure: false
})
export class MessageTypePipe implements PipeTransform {
    constructor(private localizationService: LocalizationService) { }

    transform(value: MessageType | string): string {
        if (!value) return '';

        const currentLang = this.localizationService.getCachedLanguage();
        return currentLang === 'ar'
            ? MessageTypeTranslations[value as MessageType] || value
            : value;
    }
}